/** Resolve catalog images from MySQL-backed product rows only (no static fallbacks). */

export function firstProductImage(productList) {
  const list = productList || [];
  const hit = list.find((p) => String(p?.image || '').trim());
  return hit ? String(hit.image).trim() : '';
}

export function thumbForGroup(productList, groupKey) {
  const list = productList || [];
  if (groupKey) {
    const inGroup = list.find(
      (p) => (p.type === groupKey || p.subcategory === groupKey) && String(p?.image || '').trim()
    );
    if (inGroup?.image) return String(inGroup.image).trim();
  }
  return firstProductImage(list);
}
